import React from 'react'

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { AppTransmissionAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"


export default function AlertsTransmission() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().transmission)

	return <AppTransmissionAutocomplete
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/transmission`}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'transmission')}
	/>
}